import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserUniversityGame from 'src/games/UniversityGame/Main';

interface UniversityGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class UniversityGame extends React.Component<UniversityGameProps> {
    constructor(props: UniversityGameProps) {
        super(props);
        bindAllOfThis(this, UniversityGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserUniversityGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default UniversityGame;



// WEBPACK FOOTER //
// ./src/pages/game/UniversityGame.tsx